import { PublicEventsService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';

import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

import { environment } from '../environments/environment';
import { CheckAuth } from './core/auth/auth.actions';
import { AppState } from './core/core.state';
import { isLoadingSpinnerActive } from './core/loader/loader.selectors';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  isLoading: Observable<boolean>;

  showBanner = false;
  private deferredPrompt: { prompt: () => void; userChoice: Promise<any>; };

  constructor(
    private swUpdate: SwUpdate,
    private store: Store<AppState>,
    private title: Title,
    private translateService: TranslateService,
    private router: Router,
    private eventService: PublicEventsService) {

    this.title.setTitle(environment.appName);

    this.store.dispatch(new CheckAuth());
  }

  ngOnInit(): void {
    this.isLoading = this.store.pipe(select(isLoadingSpinnerActive));

    if (this.swUpdate.isEnabled) {
      this.swUpdate.available.subscribe(() => {
        if (confirm('Nuova versione disponibile. Caricare la nuova versione?')) {
          window.location.reload();
        }
      });
    }

  }

  public install() {
    // Show the prompt
    this.deferredPrompt.prompt();
    // Wait for the user to respond to the prompt
    this.deferredPrompt.userChoice.then((choiceResult: { outcome: string; }) => {

      this.showBanner = false;
      this.deferredPrompt = null;
    });
  }

  public dismiss() {
    this.showBanner = false;
    this.deferredPrompt = null;
  }
}
